import { render, staticRenderFns } from "./Placeholder.vue?vue&type=template&id=8ebb41e2&scoped=true&"
var script = {}
import style0 from "./Placeholder.vue?vue&type=style&index=0&id=8ebb41e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebb41e2",
  null
  
)

export default component.exports